import React, { useState, useEffect } from 'react';
import './ConnectivityHandler.css';

/**
 * ConnectivityHandler
 *
 * Shows a top banner when the user's device loses network connectivity.
 * Displays a "back online" confirmation for 3 seconds after the connection
 * is restored.
 */
const ConnectivityHandler = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setWasOffline(true);
      setTimeout(() => setWasOffline(false), 3000);
    };

    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <>
      {!isOnline && (
        <div className="connectivity-banner offline">
          You are offline. Uploads will resume once your connection is restored.
        </div>
      )}

      {wasOffline && isOnline && (
        <div className="connectivity-banner online">
          Connection restored. Resuming uploads...
        </div>
      )}
    </>
  );
};

export default ConnectivityHandler;
